import { clues } from "@/mocks/eventArchive";

const stateDot: Record<string, string> = {
  待确认: "text-accent-800 bg-accent-100 border-accent-300",
  关注中: "text-accent-800 bg-accent-100 border-accent-300",
  寻找源: "text-secondary-900 bg-secondary-100 border-secondary-200",
  存疑: "text-foreground-700 bg-background-200 border-background-300",
  待更新: "text-primary-800 bg-primary-100 border-primary-200",
};

const stateIcon: Record<string, string> = {
  待确认: "ri-question-line",
  关注中: "ri-eye-line",
  寻找源: "ri-search-eye-line",
  存疑: "ri-alarm-line",
  待更新: "ri-hourglass-line",
};

export default function ClueSection() {
  return (
    <section id="yidian" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>疑点清单
            </span>
            <h2 className="font-head-cn mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              还没合上的拼图
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-700">
              整件事卡住，往往不是因为两边吵得凶，而是这几块<b className="text-foreground-950">关键证据始终没对上</b>。
              我们把「缺什么、卡在哪、状态如何」单独列成一张待办清单，跟着它看，比跟着情绪看更清楚。
            </p>
            <a
              href="#taolun"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap"
            >
              去评论区找线索<i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="space-y-4 lg:col-span-3">
            {clues.map((c, i) => (
              <div
                key={i}
                className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-5 md:flex-row md:items-center md:justify-between"
              >
                <div className="flex items-start gap-3">
                  <span className="font-num mt-0.5 text-lg text-foreground-400">0{i + 1}</span>
                  <p className="text-sm leading-6 text-foreground-800">{c.text}</p>
                </div>
                <span
                  className={`inline-flex w-fit shrink-0 items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold whitespace-nowrap ${stateDot[c.state] || stateDot["待确认"]}`}
                >
                  <i className={stateIcon[c.state] || "ri-question-line"}></i>{c.state}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}